import React from 'react';
import './App.css';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { ToastContainer } from "react-toastify";
import Routes from "src/components/routes/routes";

const theme = createTheme({
  typography: {
    fontFamily: ["Poppins", "sans-serif"].join(","),
  },
});
const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <Routes />
      <ToastContainer position="bottom-right" newestOnTop
        toastStyle={{
          // border: "1px solid transparent",
    //       background: `url(./greenhalfcircle.png) no-repeat bottom right, linear-gradient(#0A0A0B, #0A0A0B) padding-box, radial-gradient(circle at top center, #fff -10%, #373737 40%) border-box,
    // url(./boxTopShadowHalf.png) no-repeat`,
          // backgroundSize: "auto, auto",
          // backgroundPosition: "bottom right, center top -200px",
          // background:
          //   "url(./greenhalfcircle.png) no-repeat bottom right, linear-gradient(#0A0A0B, #0A0A0B) padding-box, radial-gradient(circle at top center, #fff -10%, #373737 40%) border-box",
          borderRadius: '10px',
          fontFamily: 'Poppins',
          fontWeight: "300",
          fontSize: '15px',
          color: "#000",
          boxShadow: '0 0 16px 0px #2a2525'
        }}
      />
    </ThemeProvider>
  )
};

export default App;